import { render, staticRenderFns } from "./UserTeam.vue?vue&type=template&id=007bb60a&"
import script from "./UserTeam.vue?vue&type=script&lang=js&"
export * from "./UserTeam.vue?vue&type=script&lang=js&"
import style0 from "./UserTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports